import { render, staticRenderFns } from "./velo-publicitaire.vue?vue&type=template&id=4570dbd8&scoped=true&"
import script from "./velo-publicitaire.vue?vue&type=script&lang=js&"
export * from "./velo-publicitaire.vue?vue&type=script&lang=js&"
import style0 from "./velo-publicitaire.vue?vue&type=style&index=0&id=4570dbd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4570dbd8",
  null
  
)

export default component.exports